import { render, staticRenderFns } from "./setPermission.vue?vue&type=template&id=9bc125b2&"
import script from "./setPermission.vue?vue&type=script&lang=js&"
export * from "./setPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports